import React from "react";
import { Ideas } from "../../components/tasks/idea";
import { getPathFromRouter, isPME_TEAM } from "../../helper";
import { useAppContext } from "../../context";

export function IdeaTaskPagePolaris(...props) {
    const path = getPathFromRouter(props);

    const { currentUser } = useAppContext();
    const isPME = isPME_TEAM(currentUser);

    return isPME ? (
        <Ideas path={path} />
    ) : (
        <p>You don't have privilege to accept this page</p>
    );
}
